import { ListingUris } from 'graphql.generated';

const getDetailsLink = (
    searchIdentifier: string | undefined,
    listingUris: ListingUris | undefined
) => {
    const searchIdentifierQueryString = searchIdentifier
        ? `?search_identifier=${searchIdentifier}`
        : '';

    const detailsLink = listingUris?.detail
        ? `${listingUris?.detail}${searchIdentifierQueryString}`
        : '#';

    return detailsLink;
};

export default getDetailsLink;
